'use strict';

var GridSendFlightButtonDirective = function GridSendFlightButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-send-flight-button.html'),
    controller: 'GridSendFlightButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', $scope.onRowSelection);
    }
  };
};
GridSendFlightButtonDirective.$inject = [];
module.exports = GridSendFlightButtonDirective;